<template>
    <div class="capacidade-card">
      <div class="capacidade-header">
        <h4>📊 Resumo Geral da Capacidade</h4>
        <div class="timestamp">
          Atualizado: {{ formatarHora(new Date()) }}
        </div>
      </div>
  
      <!-- Grid de Estatísticas -->
      <div class="capacidade-stats">
        <div class="stat-group">
          <div class="stat-item principal">
            <div class="stat-icon">🏭</div>
            <div class="stat-content">
              <div class="stat-label">Total de Setores</div>
              <div class="stat-value">{{ dados?.total_setores || 0 }}</div>
            </div>
          </div>
  
          <div class="stat-item success">
            <div class="stat-icon">✅</div>
            <div class="stat-content">
              <div class="stat-label">Setores Ativos</div>
              <div class="stat-value">{{ dados?.setores_ativos || 0 }}</div>
            </div>
          </div>
  
          <div class="stat-item info">
            <div class="stat-icon">👥</div>
            <div class="stat-content">
              <div class="stat-label">Funcionários Trabalhando</div>
              <div class="stat-value">{{ dados?.total_funcionarios_trabalhando || 0 }}</div>
            </div>
          </div>
        </div>
  
        <div class="stat-group">
          <div class="stat-item warning">
            <div class="stat-icon">⏱️</div>
            <div class="stat-content">
              <div class="stat-label">Capacidade Total</div>
              <div class="stat-value">{{ dados?.capacidade_total_horas || 0 }}h</div>
            </div>
          </div>
  
          <div class="stat-item" :class="getCorUtilizacao(dados?.utilizacao_percentual)">
            <div class="stat-icon">📈</div>
            <div class="stat-content">
              <div class="stat-label">Utilização</div>
              <div class="stat-value">{{ dados?.utilizacao_percentual || 0 }}%</div>
            </div>
          </div>
  
          <div class="stat-item secondary">
            <div class="stat-icon">🔄</div>
            <div class="stat-content">
              <div class="stat-label">Setores Inativos</div>
              <div class="stat-value">{{ dados?.setores_inativos || 0 }}</div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Barra de Progresso Geral -->
      <div class="progresso-geral">
        <div class="progresso-header">
          <span class="progresso-titulo">Utilização Geral da Capacidade</span>
          <span class="progresso-percentual">{{ dados?.utilizacao_percentual || 0 }}%</span>
        </div>
        <div class="progresso-barra-container">
          <div class="progresso-barra">
            <div 
              class="progresso-fill"
              :class="getCorUtilizacao(dados?.utilizacao_percentual)"
              :style="{ width: (dados?.utilizacao_percentual || 0) + '%' }"
            ></div>
          </div>
        </div>
        <div class="progresso-legenda">
          <span class="legenda-item success">
            <span class="legenda-cor"></span>
            0-50% Normal
          </span>
          <span class="legenda-item warning">
            <span class="legenda-cor"></span>
            51-80% Atenção
          </span>
          <span class="legenda-item danger">
            <span class="legenda-cor"></span>
            81-100% Crítico
          </span>
        </div>
      </div>
  
      <!-- Estatísticas Detalhadas (se disponível) -->
      <div v-if="estatisticas" class="estatisticas-detalhadas">
        <h5>📋 Detalhes da Operação</h5>
        <div class="detalhes-grid">
          <div class="detalhe-item">
            <span class="detalhe-label">Tempo Utilizado:</span>
            <span class="detalhe-valor">{{ estatisticas.tempo_utilizado_horas || 0 }}h</span>
          </div>
          <div class="detalhe-item">
            <span class="detalhe-label">Tempo Restante:</span>
            <span class="detalhe-valor">{{ estatisticas.tempo_restante_horas || 0 }}h</span>
          </div>
          <div class="detalhe-item">
            <span class="detalhe-label">Eficiência Média:</span>
            <span class="detalhe-valor">{{ calcularEficiencia() }}%</span>
          </div>
        </div>
      </div>
  
      <!-- Indicadores de Status -->
      <div class="status-indicators">
        <div 
          class="status-indicator"
          :class="{ 'ativo': dados?.setores_ativos > 0 }"
        >
          <span class="indicator-dot"></span>
          Sistema {{ dados?.setores_ativos > 0 ? 'Operacional' : 'Parado' }}
        </div>
        
        <div 
          class="status-indicator"
          :class="{ 'ativo': dados?.total_funcionarios_trabalhando > 0 }"
        >
          <span class="indicator-dot"></span>
          Produção {{ dados?.total_funcionarios_trabalhando > 0 ? 'Ativa' : 'Inativa' }}
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'CapacidadeCard',
    
    props: {
      dados: {
        type: Object,
        default: () => ({})
      },
      estatisticas: {
        type: Object,
        default: null
      }
    },
    
    methods: {
      getCorUtilizacao(percentual) {
        if (!percentual) return 'success';
        if (percentual >= 80) return 'danger';
        if (percentual >= 50) return 'warning';
        return 'success';
      },
  
      formatarHora(data) {
        return data.toLocaleTimeString('pt-BR', {
          hour: '2-digit',
          minute: '2-digit'
        });
      },
  
      calcularEficiencia() {
        if (!this.estatisticas) return 0;
        
        const tempoTotal = this.estatisticas.tempo_utilizado_horas || 0;
        const capacidadeTotal = this.dados?.capacidade_total_horas || 0;
        
        if (capacidadeTotal === 0) return 0;
        
        return Math.round((tempoTotal / capacidadeTotal) * 100);
      }
    }
  }
  </script>
  
  <style scoped>
  .capacidade-card {
    background: white;
    border-radius: 12px;
    padding: 25px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
    border: 1px solid #e0e0e0;
  }
  
  .capacidade-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 25px;
    padding-bottom: 15px;
    border-bottom: 2px solid #f0f0f0;
  }
  
  .capacidade-header h4 {
    margin: 0;
    color: #333;
    font-size: 18px;
    font-weight: 600;
  }
  
  .timestamp {
    font-size: 12px;
    color: #666;
    background: #f5f5f5;
    padding: 4px 8px;
    border-radius: 4px;
  }
  
  /* Grid de Estatísticas */
  .capacidade-stats {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-bottom: 25px;
  }
  
  .stat-group {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  
  .stat-item {
    display: flex;
    align-items: center;
    padding: 15px;
    border-radius: 8px;
    border-left: 4px solid var(--stat-color);
    background: var(--stat-bg);
    transition: all 0.3s ease;
  }
  
  .stat-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }
  
  .stat-item.principal { --stat-color: #1976d2; --stat-bg: #e3f2fd; }
  .stat-item.success { --stat-color: #4caf50; --stat-bg: #e8f5e8; }
  .stat-item.info { --stat-color: #2196f3; --stat-bg: #e3f2fd; }
  .stat-item.warning { --stat-color: #ff9800; --stat-bg: #fff3e0; }
  .stat-item.danger { --stat-color: #f44336; --stat-bg: #ffebee; }
  .stat-item.secondary { --stat-color: #757575; --stat-bg: #f5f5f5; }
  
  .stat-icon {
    font-size: 24px;
    margin-right: 15px;
    width: 40px;
    text-align: center;
  }
  
  .stat-content {
    flex: 1;
  }
  
  .stat-label {
    font-size: 13px;
    color: #666;
    margin-bottom: 4px;
    font-weight: 500;
  }
  
  .stat-value {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    line-height: 1;
  }
  
  /* Progresso Geral */
  .progresso-geral {
    margin-bottom: 25px;
    padding: 20px;
    background: #f9f9f9;
    border-radius: 8px;
  }
  
  .progresso-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }
  
  .progresso-titulo {
    font-weight: 600;
    color: #333;
    font-size: 14px;
  }
  
  .progresso-percentual {
    font-weight: bold;
    font-size: 16px;
    color: #1976d2;
  }
  
  .progresso-barra-container {
    margin-bottom: 10px;
  }
  
  .progresso-barra {
    background: #e0e0e0;
    height: 12px;
    border-radius: 6px;
    overflow: hidden;
    position: relative;
  }
  
  .progresso-fill {
    height: 100%;
    transition: width 0.5s ease;
    position: relative;
  }
  
  .progresso-fill.success { 
    background: linear-gradient(90deg, #4caf50, #8bc34a); 
  }
  .progresso-fill.warning { 
    background: linear-gradient(90deg, #ff9800, #ffc107); 
  }
  .progresso-fill.danger { 
    background: linear-gradient(90deg, #f44336, #ff5722); 
  }
  
  .progresso-legenda {
    display: flex;
    justify-content: space-between;
    font-size: 11px;
  }
  
  .legenda-item {
    display: flex;
    align-items: center;
    gap: 4px;
    color: #666;
  }
  
  .legenda-cor {
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }
  
  .legenda-item.success .legenda-cor { background: #4caf50; }
  .legenda-item.warning .legenda-cor { background: #ff9800; }
  .legenda-item.danger .legenda-cor { background: #f44336; }
  
  /* Estatísticas Detalhadas */
  .estatisticas-detalhadas {
    margin-bottom: 20px;
    padding: 15px;
    background: #f0f8ff;
    border-radius: 8px;
    border: 1px solid #e3f2fd;
  }
  
  .estatisticas-detalhadas h5 {
    margin: 0 0 15px 0;
    color: #1976d2;
    font-size: 14px;
  }
  
  .detalhes-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 10px;
  }
  
  .detalhe-item {
    display: flex;
    justify-content: space-between;
    padding: 8px 12px;
    background: white;
    border-radius: 4px;
    font-size: 13px;
  }
  
  .detalhe-label {
    color: #666;
  }
  
  .detalhe-valor {
    font-weight: bold;
    color: #333;
  }
  
  /* Indicadores de Status */
  .status-indicators {
    display: flex;
    gap: 20px;
    justify-content: center;
  }
  
  .status-indicator {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    border-radius: 20px;
    background: #f5f5f5;
    color: #666;
    font-size: 12px;
    font-weight: 500;
    transition: all 0.3s ease;
  }
  
  .status-indicator.ativo {
    background: #e8f5e8;
    color: #2e7d32;
  }
  
  .indicator-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #ccc;
    transition: all 0.3s ease;
  }
  
  .status-indicator.ativo .indicator-dot {
    background: #4caf50;
    animation: pulse 2s infinite;
  }
  
  @keyframes pulse {
    0% { opacity: 1; }
    50% { opacity: 0.5; }
    100% { opacity: 1; }
  }
  
  /* Responsividade */
  @media (max-width: 768px) {
    .capacidade-card {
      padding: 20px;
    }
    
    .capacidade-stats {
      grid-template-columns: 1fr;
      gap: 15px;
    }
    
    .stat-group {
      gap: 10px;
    }
    
    .stat-item {
      padding: 12px;
    }
    
    .stat-icon {
      font-size: 20px;
      margin-right: 10px;
      width: 30px;
    }
    
    .stat-value {
      font-size: 18px;
    }
    
    .progresso-legenda {
      flex-direction: column;
      gap: 5px;
    }
    
    .detalhes-grid {
      grid-template-columns: 1fr;
    }
    
    .status-indicators {
      flex-direction: column;
      gap: 10px;
    }
  }
  
  @media (max-width: 480px) {
    .capacidade-header {
      flex-direction: column;
      gap: 10px;
      text-align: center;
    }
    
    .progresso-header {
      flex-direction: column;
      gap: 5px;
      text-align: center;
    }
  }
  </style>